import { useParams, useSearchParams } from "react-router";
import { useEffect } from "react";
import { ConnectLoading } from "./ConnectLoading";
import { useGetNextState } from "../../hooks/useGetNextState";
import { SESSION_STORAGE_KEYS, sessionStorageService } from "../../services/sessionStorage";

export function ConnectStart() {
  const { linkToken } = useParams();
  const { getNextState } = useGetNextState(linkToken || "");
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const origin = searchParams.get("origin");
    const systemIdentifier = searchParams.get("systemIdentifier");

    if (origin) {
      sessionStorageService.set(SESSION_STORAGE_KEYS.hostOrigin, origin);
    }
    if (systemIdentifier) {
      sessionStorageService.set(SESSION_STORAGE_KEYS.systemIdentifier, systemIdentifier);
    }
  }, [searchParams]);

  useEffect(() => {
    getNextState("start", {
      type: "continue",
    });
  }, []);

  return <ConnectLoading />;
}
